/**
 * Product card image navigation — chevron arrows to cycle through all product images.
 * Extra images are stored as JSON in data-extra-images and created lazily.
 *
 * Performance strategy:
 * - Only the first image is in the HTML on page load.
 * - On mouseenter: the second and last images are pre-fetched into browser cache
 *   using Image() objects (no DOM changes), so both chevron directions feel instant.
 * - On first chevron click: all slides are created in correct order and since the
 *   edge images are already cached, they display immediately.
 *
 * Uses a window flag to prevent duplicate listener registration (snippet renders
 * once per product card, so without the guard we'd register N listeners per page).
 */
(function () {
  if (window.__cardImageNavInit) return;
  window.__cardImageNavInit = true;

  function getSlides(card) {
    return card.querySelectorAll('.card-img-slide');
  }

  function showSlide(slides, index) {
    slides.forEach(function (slide, i) {
      slide.style.opacity = i === index ? '1' : '0';
    });
  }

  function getCurrentIndex(card) {
    return parseInt(card.getAttribute('data-img-index') || '0', 10);
  }

  function setCurrentIndex(card, index) {
    card.setAttribute('data-img-index', index);
  }

  function parseExtraImages(card) {
    var raw = card.getAttribute('data-extra-images');
    if (!raw) return [];
    try { return JSON.parse(raw) || []; } catch (e) { return []; }
  }

  // On mouseenter: warm the browser cache for second and last images
  // so the first chevron click in either direction feels instant
  function prefetchEdgeImages(card) {
    if (card.__edgesPrefetched) return;
    card.__edgesPrefetched = true;

    var images = parseExtraImages(card);
    if (!images.length) return;

    // Prefetch second image (for > next)
    var img1 = new Image();
    img1.src = images[0].src;

    // Prefetch last image (for < prev), if different from the second
    if (images.length > 1) {
      var imgLast = new Image();
      imgLast.src = images[images.length - 1].src;
    }
  }

  // On first click: create all slides in correct order
  function lazyLoadAllSlides(card) {
    if (card.__allSlidesLoaded) return;
    card.__allSlidesLoaded = true;

    var images = parseExtraImages(card);
    if (!images.length) return;

    var link = card.querySelector('.product-link');
    if (!link) return;

    images.forEach(function (img) {
      var slide = document.createElement('div');
      slide.className = 'card-img-slide';
      var imgEl = document.createElement('img');
      imgEl.src = img.src;   // loads from cache if prefetched
      imgEl.alt = img.alt || '';
      imgEl.loading = 'eager';
      imgEl.decoding = 'async';
      slide.appendChild(imgEl);
      link.appendChild(slide);
    });
  }

  // Mouseenter: prefetch edge images into browser cache
  document.addEventListener('mouseenter', function (e) {
    var card = e.target.closest('.card-product__media-has-nav');
    if (card) prefetchEdgeImages(card);
  }, true);

  // Click: cycle images
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.card-img-nav-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var card = btn.closest('.card-product__media-inner');
    if (!card) return;

    // Ensure edge images are prefetched (fallback if hover didn't fire)
    prefetchEdgeImages(card);
    // Create all slides in correct order on first click
    lazyLoadAllSlides(card);

    var slides = getSlides(card);
    var total = slides.length;
    if (total < 2) return;

    var current = getCurrentIndex(card);
    var dir = btn.classList.contains('card-img-nav-next') ? 1 : -1;
    var next = (current + dir + total) % total;

    showSlide(slides, next);
    setCurrentIndex(card, next);
  }, true);
})();
